import axios from "axios"
import { TokenService } from "@/services/token.service"
import store from "@/store"
import router from "@/router"

const AUTH_BASE = '/api/ife/rest/v1'
axios.defaults.baseURL = AUTH_BASE

// ----- request interceptor (JWT) -----
axios.interceptors.request.use(config => {
  // use namespaced general module for loading spinner
  store.commit('general/setLoading', true)
  const token = TokenService.token()
  if (token && !config.url?.includes('/login') && !config.url?.includes('/refresh')) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// ----- response interceptor -----
axios.interceptors.response.use(
  response => {
    store.commit('general/setLoading', false)
    return response
  },
  error => {
    store.commit('general/setLoading', false)
    if (error.response?.status === 401) {
      store.commit('auth/login', null) // triggers logout? actually we need to commit auth delete
      router.push("/auth/login")
    }
    return Promise.reject(error)
  }
)

const ApiService = {
  setHeader() {
    axios.defaults.headers.common.Authorization = `Bearer ${TokenService.token()}`
  },
  removeHeader() {
    delete axios.defaults.headers.common.Authorization
  },
  get(resource, config) { return axios.get(resource, config) },
  getT(resource, config) {
    const tenant = store.getters.activeEntity
    const prefix = tenant ? `tenant/${tenant}/` : ''
    return axios.get(`${prefix}${resource}`, config)
  },
  post(resource, data) { return axios.post(resource, data) },
  postT(resource, data) {
    const tenant = store.getters.activeEntity
    const prefix = tenant ? `tenant/${tenant}/` : ''
    return axios.post(`${prefix}${resource}`, data)
  },
  put(resource, data) { return axios.put(resource, data) },
  putT(resource, data) {
    const tenant = store.getters.activeEntity
    const prefix = tenant ? `tenant/${tenant}/` : ''
    return axios.put(`${prefix}${resource}`, data)
  },
  delete(resource) { return axios.delete(resource) },
  deleteT(resource) {
    const tenant = store.getters.activeEntity
    const prefix = tenant ? `tenant/${tenant}/` : ''
    return axios.delete(`${prefix}${resource}`)
  },
  customRequest(data) { return axios(data) },
  tenantPrefix() {
    const tenant = store.getters.activeEntity
    return tenant ? `tenant/${tenant}/` : ''
  },
  // --- auth module ---
  auth: {
    login: (credentials) => ApiService.post("login", credentials),
    refreshToken: (refreshToken) => ApiService.customRequest({
      url: "/refresh",
      method: "post",
      data: {},
      headers: { Authorization: `Bearer ${refreshToken}` },
      silent: true
    }),
    getAccount: (username, entity) => {
      if (entity === '__landlord__entity') {
        return ApiService.get(`account/${username}`)
      }
      return ApiService.getT(`account/${username}`)
    }
  }
}

export default ApiService